import { Controller } from "@hotwired/stimulus"
import { allDeploymentStatusesStore } from "../../../stores/deployment_statuses/all_deployment_statuses_store"
import { useStore } from "stimulus-store"
import { sendFailureNotification } from "shared/toast_notifications"
import { getDeploymentStatuses } from "shared/selects/deployment_statuses"

// Connects to data-controller="suppliers--deployment-statuses--deployment-statuses-supplier"
export default class extends Controller {

    static stores = [
        allDeploymentStatusesStore
    ]

    static values = {
        autoLoad: Boolean
    }

    connect() {
        useStore(this)

        // If autoLoad is enabled, load deployment statuses immediately
        if (this.autoLoadValue) {
            this.loadDeploymentStatuses()
        }
    }

    /**
     * Load all deployment statuses and populate the allDeploymentStatusesStore
     */
    async loadDeploymentStatuses() {
        try {
            // Fetch all deployment statuses using the existing service
            const deploymentStatuses = await getDeploymentStatuses()

            // Update the store with fetched deployment statuses
            this.setAllDeploymentStatusesStoreValue(deploymentStatuses)
        } catch (error) {
            console.error('Error loading deployment statuses:', {
                error: error.message,
                timestamp: new Date().toISOString()
            })

            // Show user-friendly error message
            sendFailureNotification('Unable to load deployment statuses. Please try again.')

            // Clear deployment statuses on error
            this.setAllDeploymentStatusesStoreValue([])
        }
    }

    /**
     * Manually refresh deployment statuses
     */
    refreshDeploymentStatuses() {
        this.loadDeploymentStatuses()
    }

    /**
     * Clear all deployment statuses from the store
     */
    clearDeploymentStatuses() {
        this.setAllDeploymentStatusesStoreValue([])
    }
}